import BankCount from './bank_count.vue';

export default BankCount;
